import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddDestinationComponent } from './add-destination/add-destination.component';
import { DestinationsLogComponent } from './destinations-log/destinations-log.component';




const routes: Routes = [
    {
        path: '',
        redirectTo: '/add',
        pathMatch: 'full'
      },
    {
      path: 'add',
      component: AddDestinationComponent
    },
    {
      path: 'edit/:id',
      component: AddDestinationComponent
    },
    {
      path: 'list',
      component: DestinationsLogComponent
    },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DestinationsRoutingModule { }
